module.exports = __webpack_public_path__ + "img/IMG_9511.561536f3.jpg";